import { Button, Modal, Spinner } from 'flowbite-react';
import { RiDeleteBin6Fill } from 'react-icons/ri';

type Props = {
	id: string;
	onDelete: (id: string, index: number) => void;
	isDeleteModalOpen: boolean;
	setIsDeleteModalOpen: (isDeleteModalOpen: boolean) => void;
	isLoading: boolean;
	index: number;
};

const DeleteProfileDetails = ({ index, onDelete, id, isDeleteModalOpen, setIsDeleteModalOpen, isLoading }: Props) => {
	const handleDelete = () => {
		onDelete(id, index);
	};
	return (
		<>
			<RiDeleteBin6Fill className="cursor-pointer" onClick={() => setIsDeleteModalOpen(true)} />
			<Modal
				dismissible={true}
				show={isDeleteModalOpen}
				onClose={() => setIsDeleteModalOpen(false)}
				size="lg"
				className="hukumu-delete-profile-details-modal backdrop-blur-[4px]"
			>
				<div className="hukumu-delete-profile-details-modal-child">
					<Modal.Header className="rounded-t-md border-b-0 dark:bg-[#1F2A37]">
						<div>
							<p className="font-inter text-[20px] font-[700] dark:text-white">Are you sure you want to delete?</p>
						</div>
					</Modal.Header>
					{/* <Modal.Body className="bg-[#1F2A37] !pt-[8px]"></Modal.Body> */}
					<Modal.Footer className="rounded-b-md border-t-0 dark:bg-[#1F2A37]">
						<div className="flex w-full justify-end gap-4">
							<Button color="light" onClick={() => setIsDeleteModalOpen(false)} disabled={isLoading}>
								Cancel
							</Button>
							<Button className="w-[77px]" color="failure" onClick={handleDelete} disabled={isLoading}>
								{isLoading ? <Spinner /> : 'Delete'}
							</Button>
						</div>
					</Modal.Footer>
				</div>
			</Modal>
		</>
	);
};

export default DeleteProfileDetails;
